import { useFrame } from '@react-three/fiber';
import React, { useRef, useEffect, useMemo } from 'react';
import * as THREE from 'three';

import { Shape, ShapeGeometry, MeshStandardMaterial } from 'three';

const MyShape = ({ position, onClick, points }) => {
  const meshRef = useRef();
  const animRef = useRef(1);
  const shortPosition = useMemo(() => {
    const factor = 0.6;
    return [position[0] * factor, position[1] * factor, position[2] * factor];
  }, [position]);

  const geometry = useMemo(() => {
    const myShape = new Shape();
    points.forEach((p, index) => {
      if (index === 0) {
        myShape.moveTo(p.x, p.y);
      } else {
        myShape.lineTo(p.x, p.y);
      }
    });
    return new ShapeGeometry(myShape);
  }, [points]);

  const material = useMemo(() => {
    return new MeshStandardMaterial({
      color: 0xedeb3e,
      transparent: true,
      opacity: 0.6,
    });
  }, []);

  useEffect(() => {
    const lookAtVector = new THREE.Vector3(0, 0, 0);
    meshRef.current.lookAt(lookAtVector);
  }, [meshRef]);

  useFrame((state, delta) => {
    if (animRef.current === 1) {
      const newOpacity = material.opacity + delta;
      if (newOpacity > 0.7) {
        animRef.current = -1;
        material.opacity = 0.7;
      } else {
        material.opacity = newOpacity;
      }
    } else {
      const newOpacity = material.opacity - delta;
      if (newOpacity < 0) {
        animRef.current = 1;
        material.opacity = 0;
      } else {
        material.opacity = newOpacity;
      }
    }
  });

  return (
    <mesh
      ref={meshRef}
      name="machine-shape"
      scale={10}
      // onClick={onClick}
      position={shortPosition}
      geometry={geometry}
      material={material}
      renderOrder={2}
    />
  );
};

const ShapeIndicator = (props) => {
  return (
    <MyShape
      position={props.position}
      points={props.points}
      // onClick={props.onClick}
    />
  );
};

export default React.memo(ShapeIndicator);
